<template>
  <div>
    <v-overlay v-if="loadingData == true">Cargando</v-overlay>
    <p style="overflow: hidden; width: auto">
      Seleccione hotel del jugador. Se sugieren horas de pickup
    </p>
    <!--<select @change="getTransportationData"   v-model="index_hotel" class="ui fluid dropdown" placeholder="Hotel para transportación">
            <option  value="" disabled>Seleccione un hotel</option>
            <template v-for="(hotel,index) in hoteles">
                <option :key="index" :value="hotel.Codigo">{{hotel.Nombre}}</option>
            </template>
        </select>-->
    <div>
      <div v-if="!modeEp">
        <v-autocomplete
          v-model="index_hotel"
          :items="comp_hoteles"
          item-value="id"
          @change="getTransportationData"
        >
        </v-autocomplete>
      </div>
      <div v-if="modeEp">
        <Select2
          v-model="index_ephotel"
          :options="comp_hotelesEP"
          @change="getTransportationDataEp"
        />
      </div>
    </div>
    <div>
      <div v-if="loaded">
        <i class="taxi icon"></i>
        <div>
          <div>Transportation Info (approximate times)</div>

          <div style="margin-top: 10px">
            <h4 style="margin-bottom: 5px">Hotel pickup:</h4>
            <div>
              <div>
                {{ HtlPickup.format(" DD-MMM-YYYY ") }}
              </div>
              <!--<input type="text" :value=" HtlPickup.format(' HH:mm ')"  placeholder="Pickup Hotel">-->
              <div>
                <datetime
                  type="time"
                  input-id="iniTime"
                  value-zone="America/Cancun"
                  zone="America/Cancun"
                  v-model="htime"
                  :auto="false"
                  :format="{ hour: 'numeric', minute: '2-digit' }"
                  :minute-step="10"
                >
                </datetime>
              </div>
            </div>
          </div>

          <div style="margin-top: 10px">
            <h4 style="margin-bottom: 5px">Golf Course PickUp:</h4>
            <div>
              <div>
                {{ PCGCPickup.format(" DD-MMM-YYYY ") }}
              </div>
              <datetime
                type="time"
                input-id="endTime"
                value-zone="America/Cancun"
                zone="America/Cancun"
                v-model="gtime"
                :min-datetime="initialHour"
                :auto="false"
                :format="{ hour: 'numeric', minute: '2-digit' }"
                :minute-step="10"
              >
              </datetime>
            </div>
          </div>
          <div style="margin-top: 10px">
            <h4 style="margin-bottom: 5px">Travel Time:</h4>
            <div>
              <div>
                {{ DuracionViaje }}
              </div>
            </div>
          </div>
          <div>
            <select
              v-model="typeTransportation"
              name="typeTransportation"
              @change="changeTypeTransportation"
              placeholder="Seleccione una tipo de transportación"
            >
              <option value="1">ROUND TRIP</option>
              <!--<option value="2" >ONE WAY - HOTEL -> GOLF CLUB</option>
                        <option value="3" >ONE WAY - GOLF CLUB -> HOTEL</option>-->
            </select>
          </div>
          <div style="margin-top: 10px">
            <h4 style="margin-bottom: 5px">Total:</h4>
            <div>
              <div v-if="!editPrice">
                {{ TotalTrans }} {{ addOn.transport.Moneda }}
              </div>
              <div v-if="editPrice">Precio en USD</div>

              <input
                type="number"
                v-if="editPrice"
                v-model="TotalTrans"
                @keypress="$pgsHelper.onlyNumber($event, TotalTrans)"
                name="name"
                placeholder="Precio de la transportación en USD"
              />

              <a
                style="padding: 10px"
                v-if="!editPrice"
                href="javascript:void(0)"
                @click="enableEditPrice"
                >Editar</a
              >
            </div>
          </div>
          <div style="margin-top: 10px">
            <v-btn
              color="succces"
              @click="setData()"
            >
              Guardar información de transporte
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.select2-container {
  width: 100% !important;
}
.vdatetime-input {
  margin: 0;
  max-width: 100%;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  outline: 0;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  text-align: left;
  line-height: 1.21428571em;
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif;
  padding: 0.67857143em 1em;
  background: #fff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  color: rgba(0, 0, 0, 0.87);
  border-radius: 0.28571429rem;
  -webkit-transition: border-color 0.1s ease, -webkit-box-shadow 0.1s ease;
  transition: border-color 0.1s ease, -webkit-box-shadow 0.1s ease;
  transition: box-shadow 0.1s ease, border-color 0.1s ease;
  transition: box-shadow 0.1s ease, border-color 0.1s ease,
    -webkit-box-shadow 0.1s ease;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>

<script>
import moment from "moment";
import Select2 from "v-select2-component";
import axiosCore from "axios";
const qs = require("querystringify");

export default {
  name: "Transportacion",
  components: {
    Select2,
  },
  data() {
    return {
      typeTransportation: 1,
      loaded: false,
      editPrice: false,
      loadingData: false,
      hoteles: [],
      index_hotel: "",
      index_ephotel: "",
      Session: "",
      ApiToken: "",
      TotalTrans: 0,
      RowId: "",
      RsvaId: "",
      DuracionViaje: "",
      HtlPickup: "",
      PCGCPickup: "",
      addOn: { transport: "" },
      htime: "",
      gtime: "",
      hotelesEP: [],
    };
  },
  props: ["modeEp", "paxNumber", "prefered", "fecha", "time"],
  methods: {
    async getEpHotel() {
      let axiosInstance = axiosCore.create({
        headers: {
          "Content-Type": "text/plain",
        },
        transformRequest: (data) => {
          return JSON.stringify(data);
        },
      });
      let urlEp =
        "https://www.entertainment-plus.net/get_hotels_deeplink?term=' '";
      this.$pgsHelper.log(urlEp);
      const response = await axiosInstance.get(urlEp);

      this.hotelesEP = response.data;
    },
    enableEditPrice() {
      this.editPrice = true;
    },
    changeTypeTransportation() {
      if (this.typeTransportation == 1) {
        this.TotalTrans = this.getHotelinfoById(this.index_hotel).PrecioRT;
      } else if (this.typeTransportation == 2) {
        this.TotalTrans = this.getHotelinfoById(this.index_hotel).PrecioOWHG;
      } else if (this.typeTransportation == 3) {
        this.TotalTrans = this.getHotelinfoById(this.index_hotel).PrecioOWGH;
      }
    },
    getHotelinfoById(code) {
      let itemIndex = this.$_.findIndex(this.hoteles, { id: code });
      if (itemIndex >= 0) {
        return this.hoteles[itemIndex];
      }

      return false;
    },
    getHotelinfoByCode(code) {
      let itemIndex = this.$_.findIndex(this.hoteles, { Code: code });
      if (itemIndex >= 0) {
        return this.hoteles[itemIndex];
      }

      return false;
    },
    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      let dat = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Mayoristas/Coleccion"
      );
      this.hoteles = [];
      let arrayHoteles = Object.entries(dat.val());
      arrayHoteles.forEach((element) => {
        this.hoteles.push({ id: element[0], ...element[1] });
      });
    },
    async getAddons() {
      /*
        Obtiene las temporadas existentes en la db
        */

      const dataTr =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "Golf/Addons/Transport"
        );
      const arrayTr = await dataTr.val();
      this.addOn.transport = arrayTr;
    },
    async getTransportationDataEp() {
      //1663
      let axiosInstance = axiosCore.create({
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        transformRequest: (data) => {
          return qs.stringify(data);
        },
      });
      let urlEp = "http://10.147.18.187:84/ApiReservation/initApi";

      const response = await axiosInstance.post(urlEp, {
        Id: "1663",
        Init: `2sAQXBpUmVzZXJ2YXRpb25FbmNvZGU=AYa`,
      });
      this.ApiToken = response.data.Data.ApiToken;
      this.Session = response.data.Data.Session;

      let dataToAvailability = {
        Token: this.ApiToken,
        Session: this.Session,
        "Data[CHILD_ARRIVAL]": 0, // niños
        "Data[CHILD_DEPARTURE]": 0, // niños
        "Data[MODAL]": 0, //default
        "Data[hotelArrivalId]": this.index_ephotel, //origen - 1er servicio
        "Data[hotelDepartureId]": 2210, //destino - 1er servicio
        //'Data[hotelArrival2]': this.index_ephotel, //origen - 2o servicio (si es round trip)
        //'Data[hotelDeparture2]': 2210, //destino - 2o servicio (si es round trip)
        "Data[TYPE]": "RT", //OW - ONE WAY, RT - ROUND TRIP
        "Data[PAX]": this.paxNumber, // pasajeros
        "Data[PAX_RETURN]": this.paxNumber, //pasajeros normalmente es el mismo
      };

      const responseAvailavility = await axiosInstance.post(
        "http://10.147.18.187:84/ApiReservation/checkAvailabilityTransfers",
        dataToAvailability
      );

      if (responseAvailavility.data.Status == "Success") {
        this.TotalTrans = responseAvailavility.data.Data.Avai.Total;
        //this.loaded = true
      }
    },
    async getTransportationData() {
      this.loadingData = true;
      /* 
        Obiene la informacion de la transportacion para la reserva
        */
      this.$pgsHelper.log(this.getHotelinfoById(this.index_hotel), true);
      let data = {
        PaxNumber: this.paxNumber,
        EpHotelId: this.getHotelinfoById(this.index_hotel).Transportacion
          .ExtraParams.EpHotelId,
        DuracionViaje: this.getHotelinfoById(this.index_hotel).Transportacion
          .DuracionViaje,
        Prefered: this.prefered,
        Fecha: this.fecha + "_" + moment(this.time, "HH:mm").format("HH:mm:ss"),
      };

      this.loadingData = true;
      //var getTransportation = this.$store.getters.getFirebaseApp.fba.call('Golf-Reservas-transportationAvailability');
      return await this.$store.getters.getFirebaseApp.fba
        .call("Golf-Reservas-transportationAvailability", data, {})
        .then((result) => {
          this.$pgsHelper.log(result, true);
          this.Session = result.data.data.Session;
          this.ApiToken = result.data.data.ApiToken;
          this.TotalTrans = this.getHotelinfoById(
            this.index_hotel
          ).Transportacion.PrecioRT;
          this.RowId = result.data.data.RowId;
          this.RsvaTransId = result.data.data.RsvaTransId;
          this.rawDuracionViaje = result.data.data.DuracionViaje;
          this.DuracionViaje = moment(
            result.data.data.DuracionViaje,
            "HH:mm:ss"
          ).format("HH [Hrs] : mm [Min].");
          this.HtlPickup = moment(
            result.data.data.HtlPickup,
            "YYYY-MM-DD_HH:mm:ss"
          );
          this.PCGCPickup = moment(
            result.data.data.PCGCPickup,
            "YYYY-MM-DD_HH:mm:ss"
          );
          (this.htime = moment(
            result.data.data.HtlPickup,
            "YYYY-MM-DD_HH:mm:ss"
          ).format("HH:mm")),
            (this.gtime = moment(
              result.data.data.PCGCPickup,
              "YYYY-MM-DD_HH:mm:ss"
            ).format("HH:mm"));
          //this.Confirm= result.data.data.Confirm;
          this.loaded = true;
          this.loadingData = false;
        })
        .catch((error) => {
          this.loadingData = false;
        });
    },

    async getTransportationDataTest() {
      /* 
        Obiene la informacion de la transportacion para la reserva
        */
      /*let data = {
            PaxNumber:this.paxNumber,
            hotelCode:this.index_hotel,
            Prefered:this.prefered,
            Fecha: this.fecha+'_'+moment(this.time,'HH:mm').format('HH:mm:ss') ,
            
        }*/
      this.loadingData = true;
      //var getTransportation = this.$store.getters.getFirebaseApp.fba.call('Golf-Reservas-transportationAvailability');

      this.Session = 53454543534543;
      this.ApiToken = 45435435;
      this.TotalTrans = this.addOn.transport.Precio;
      this.RowId = 432432;
      this.RsvaTransId = 234324;
      this.rawDuracionViaje = "30:00:00";
      this.DuracionViaje = moment("00:30:00", "HH:mm:ss").format(
        "HH [Hrs] : mm [Min]."
      );
      this.HtlPickup = moment("2020-06-01_04:00:00", "YYYY-MM-DD_HH:mm:ss");
      this.PCGCPickup = moment("2020-06-01_06:00:00", "YYYY-MM-DD_HH:mm:ss");
      //this.Confirm= result.data.data.Confirm;
      this.loadingData = false;
      (this.htime = moment("2020-06-01_04:00:00", "YYYY-MM-DD_HH:mm:ss").format(
        "HH:mm"
      )),
        (this.gtime = moment(
          "2020-06-01_06:00:00",
          "YYYY-MM-DD_HH:mm:ss"
        ).format("HH:mm"));
    },
    setData() {
      this.$emit("setData", this.$data);
    },
  },
  computed: {
    initialHour() {
      if (this.htime === "") {
        return this.htime;
      } else {
        let hour = new moment(this.htime);
        //hour.add(10, 'minutes')
        return hour.format("HH:mm");
      }
    },
    comp_hotelesEP() {
      let data_hoteles = [];

      this.hotelesEP.forEach((element) => {
        data_hoteles.push({
          id: element.Id,
          value: element.Id,
          text: element.label,
        });
      });

      return data_hoteles;
    },
    comp_hoteles() {
      let data_hoteles = [];
      this.hoteles.forEach((element) => {
        if (element.ActiTrans) {
          data_hoteles.push({ id: element.id, text: element.Nombre });
        }
      });

      return data_hoteles;
    },
  },

  beforeMount: function () {},
  mounted: function () {
    this.getAddons();
    this.getHoteles();
    if (this.modeEp) {
      this.getEpHotel();
    }
  },
};
</script>
